export type RubricaSituacao = 'ATIVA' | 'INATIVA' | 'EXCLUIDA' | 'NAO_UTILIZADA' | 'DESCONHECIDA';

export type RubricaSituacaoNome =
  'Ativa' | 'Inativa' | 'Excluída' | 'Não utilizada' | 'Desconhecida';

export const RUBRICA_SITUACAO_NOMES: Record<RubricaSituacao, RubricaSituacaoNome> = {
  ATIVA: 'Ativa',
  INATIVA: 'Inativa',
  EXCLUIDA: 'Excluída',
  NAO_UTILIZADA: 'Não utilizada',
  DESCONHECIDA: 'Desconhecida',
};
